import { fromJS } from 'immutable';

import * as constants from 'actions/modal/constants';
import initialState, { ModalRecord } from './initialState';

export default (state = initialState, action) => {
  switch (action.type) {
    case constants.SHOW_MODAL: {
      const { modalProps, modalType } = action;
      const modal = new ModalRecord({
        active: true,
        props: fromJS(modalProps),
        type: modalType
      });
      return modal;
    }

    case constants.HIDE_MODAL:
      return new ModalRecord();

    default:
      return state;
  }
};
